module.exports = __webpack_public_path__ + "img/company.06d24935.png";